import { SuccessPageProps } from "@made-people/blueprint-success-page";

export const SuccessPage = {
  templateProps: {
    template: "barcelona",
    features: {
      linkVariants: {
        color: "primary",
        style: "solid",
        width: { initial: "full", lg: "auto" },
      },
      cartSummarySettings: {
        template: "birch",
        variants: {
          heading: "hide",
        },
      },
    },
  },
} satisfies SuccessPageProps;
